// App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useEffect } from "react";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Products from "./components/Products";
import ScrollToTop from "./components/ScrollToTop";
import AllProducts from "./components/AllProducts";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import SocialMediaButtons from "./components/socialMediaButtons";
import ProductDetails from "./components/ProductDetails"; // ✅ import this page

import scrollreveal from "scrollreveal";

export default function App() {
  useEffect(() => {
    const sr = scrollreveal({
      origin: "top",
      distance: "80px",
      duration: 2000,
      reset: false,
    });
    sr.reveal(
      `
        nav,
        #home,
        #services,
        #portfolio,
        #testimonials,
        #products,
        #newsletter,
        .footer
    `,
      {
        opacity: 0,
        interval: 200,
      }
    );
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/products" element={<AllProducts />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
      <Footer />
      {/* <SocialMediaButtons /> */}
    </Router>
  );
}

// Optional: extract if needed as separate file
const MainPage = () => {
  return (
    <>
      <Hero id="home" />
      <Products id="products" />
    </>
  );
};
